import * as React from "react";
import { Alert, Container, Table } from "react-bootstrap";
import Pagination from "react-bootstrap/Pagination";

export default function Nodes({ accountInfo }) {
  const [nodes, setNodes] = React.useState([]);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [totalPages, setTotalPages] = React.useState(0);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(null);

  React.useEffect(() => {
    const fetchData = async () => {
      try {
        const apiUrl = `https://smeshi-api.com/account/${
          accountInfo.address
        }/atx/8?sort=desc&limit=20&offset=${(currentPage - 1) * 20}`;
        const response = await fetch(apiUrl);
        const total = response.headers;
        const result = await response.json();

        setNodes(() => setNodes(result));
        setTotalPages(2);
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [currentPage, accountInfo]);

  const handlePageChange = (page) => {
    console.log(totalPages)
    setCurrentPage(page);
  };

  const displayNodes = () => {
    if (nodes)
      return nodes.map((n) => {
        return (
          <tr key={n.nodeId}>
            <td>{`${n.nodeId.slice(0, 4)}...${n.nodeId.slice(-4)}`}</td>
            <td>{`${n.atxId.slice(0, 4)}...${n.atxId.slice(-4)}`}</td>
            <td>{n.effectiveNumUnits}</td>
            <td>{((n.effectiveNumUnits * 64) / 1024).toFixed(2)} TiB</td>
            <td>{new Date(n.received).toLocaleString()}</td>
          </tr>
        );
      });
  };

  return (
    <Container>
        <Alert variant="danger">Currently you can only load 2 pages of Nodes</Alert>
      <Table striped bordered hover variant="dark" size="sm">
        <thead>
          <tr>
            <th>Node ID</th>
            <th>ATX ID</th>
            <th>Effective Num Units</th>
            <th>Size GiB</th>
            <th>Date Seen</th>
          </tr>
        </thead>
        <tbody>{displayNodes()}</tbody>
      </Table>
      <Pagination>
        <Pagination.Prev
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
        />
        {Array.from({ length: totalPages }).map((_, index) => (
          <Pagination.Item
            key={index + 1}
            active={index + 1 === currentPage}
            onClick={() => handlePageChange(index + 1)}
          >
            {index + 1}
          </Pagination.Item>
        ))}
        <Pagination.Next
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
        />
      </Pagination>
    </Container>
  );
}
